module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_molecular_level_of_dna_3-4dc4988c47cb32ecb7e2374c77fd9a8b.jpg";